import { observer } from 'mobx-react-lite'
import { useLocationSettingsView } from 'app/components/location-settings-view/useLocationSettingsView'
import { LocationSettingsViewShadcnComponent } from 'app/components/location-settings-view/LocationSettingsViewShadcnComponent'

export const handle = {
  breadcrumb: (matches: any[]) => {
    let matchPathData = matches.find((match) => !!match?.data?.location)
    return matchPathData?.data?.location?.name || `New`
  },
}

export default observer(function LocationView() {
  const { title, tabs, canCreateLocation } = useLocationSettingsView()
  return <LocationSettingsViewShadcnComponent title={title} tabs={tabs} canCreateLocation={canCreateLocation} />
})
